// extracted by mini-css-extract-plugin
export default {"background":"SignUp_background__Ps9Jg","signUpFormContainer":"SignUp_signUpFormContainer__lPHB1"};